/* eslint-disable camelcase */
const awsconfig = {
  aws_project_region: "ap-southeast-1",
  aws_cognito_region: "ap-southeast-1",
  aws_user_pools_id: process.env.REACT_APP_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_USER_POOL_CLIENT_ID,
};

export default awsconfig;
